<template>
  <div class="navigation-item">
    <a
      v-if="newTab"
      :href="`${historyMode}${link}`"
      :target="newTab ? '_blank' : '_self'"
    >
      <i class="material-icons">{{ materialIcon }}</i>
      <div class="navigation-item-text">{{ text }}</div>
    </a>

    <RouterLink v-else :to="{ name: link }">
      <i class="material-icons">{{ materialIcon }}</i>
      <div class="navigation-item-text">{{ text }}</div>
    </RouterLink>
  </div>
</template>

<script>
import routes from "@/router/routes";

export default {
  props: {
    name: { type: String, default: "" },
    materialIcon: { type: String, default: "" },
    text: { type: String, default: "" },
    newTab: { type: Boolean, default: false }
  },

  computed: {
    link() {
      return this.newTab
        ? routes.find(r => r.name === this.name).path
        : this.name;
    },

    historyMode() {
      return this.$router.mode === "hash" ? "/#" : "";
    }
  }
};
</script>

<style lang="css" scoped>
.navigation-item {
  width: 7.5em;
  transition: color 0.2s, transform 0.2s;
}

.navigation-item:hover,
.navigation-item:focus {
  transform: scale(1.1);
}

.navigation-item a {
  text-decoration: none;
}

.navigation-item a > i {
  /* color: #363636; */
  color: #0078a8;
}

.navigation-item a:hover > i,
.navigation-item a:focus > i {
  /* color: var(--primary); */
  color: hsl(197, 100%, 23%);
}

.navigation-item i {
  display: block;
  font-size: 3em;
  text-align: center;
}

.navigation-item-text {
  font-size: 1em;
  text-align: center;
  word-break: break-word;
}
</style>
